import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

import './AboutCTASection.css';

export default function AboutCTASection() {
  return (
    <section className="aboutcta-section">
      <div className="container">
        <div className="aboutcta-box">
          <FontAwesomeIcon
            icon={faRocket}
            size="2x"
            className="text-orange mb-3"
          />
          <h2 className="aboutcta-heading mb-3">Samen groeien?</h2>
          <p className="aboutcta-text">
            Klaar om jouw online ambities waar te maken? Ontvang vrijblijvend een
            <strong> gratis groeiscan</strong> en ontdek waar we het verschil
            kunnen maken.
          </p>

          <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
            <Link to="/contact" className="btn btn-orange btn-lg px-4">
              Vraag groeiscan aan
            </Link>
            <Link to="/contact" className="btn btn-outline-orange btn-lg px-4">
              Plan kennismaking
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
